import React, {useContext} from 'react';
import {FormattedMessage} from "react-intl";

import SidebarItem from "../../../SidebarItem";

import {ReactComponent as DocumentText} from "assets/img/document-text.svg";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {OMSRoutes} from "utils/OMSRoutes";

import {SidebarContext} from "../../../../../../SidebarContext";

function QuotesItem(props) {
    const {currentPath, currentMemberAuthorizations} = useContext(SidebarContext);

    if (!hasAuthorization(currentMemberAuthorizations, Authorizations.PICKING_RETAILER_QUOTE)) {
        return null;
    }

    const isSelected = currentPath.startsWith(OMSRoutes.QUOTES) || currentPath.startsWith(OMSRoutes.QUOTE_DETAILS);

    return (
        <SidebarItem
            isTopLevel
            icon={<DocumentText />}
            to={OMSRoutes.QUOTES}
            selected={isSelected}
        >
            <FormattedMessage id='sidebar.item.quote' />
        </SidebarItem>
    );
}

export default QuotesItem;
